import Ch5Impact from '@/chapters/Ch5Impact';

export default function ImpactPage() {
  return <Ch5Impact />;
}
